import { render, staticRenderFns } from "./QuestionBySubject.vue?vue&type=template&id=157e599c&scoped=true&"
import script from "./QuestionBySubject.vue?vue&type=script&lang=js&"
export * from "./QuestionBySubject.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBySubject.vue?vue&type=style&index=0&id=157e599c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157e599c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
installComponents(component, {VBtn,VCard,VHover})
